// AboutSigmaStudio.jsx
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGifts, faHistory, faMedal, faRankingStar, faSquare } from '@fortawesome/free-solid-svg-icons';
import MainLayout from '../../layouts/MainLayout';
import spotsnapimage from '../../assets/pageimages/SpotSnap.webp';
import './SpotSnapHome.css';


const SpotSnapHome = () => {
  return (
    <MainLayout>
      <div>
        <h2 className='text-lg mt-12 mx-8 border-b border-b-gray-300 text-white'>Think5Whys SponSnap</h2>
      </div>
      <div className="main-content">
        <div className="top-section top-section mt-4 ml-2 mr-0 border border-b-gray-300">
            <div className="button-links flex align-middle justify-center bg-gray-500">
                <div className="bottom-buttons-box"><Link to="/spotsnap-leaderboard" className="top-button-link"><FontAwesomeIcon icon={faSquare} className="donaqr-bottomlink-style" />Leaderboard</Link></div>
                <div className="bottom-buttons-box"><Link to="/spotsnap-myrank" className="top-button-link"><FontAwesomeIcon icon={faRankingStar} className="donaqr-bottomlink-style" />My Rank</Link></div>
                <div className="bottom-buttons-box"><Link to="/spotsnap-myhistory" className="top-button-link"><FontAwesomeIcon icon={faHistory} className="donaqr-bottomlink-style" />My History</Link></div>
                <div className="bottom-buttons-box"><Link to="/spotsnap-mygifts" className="top-button-link"><FontAwesomeIcon icon={faGifts} className="donaqr-bottomlink-style" />My Gift</Link></div>
                <div className="bottom-buttons-box"><Link to="/spotsnap-winners-list" className="top-button-link"><FontAwesomeIcon icon={faMedal} className="donaqr-bottomlink-style" />Winners List</Link></div>
            </div>
        </div>
        <div className="image-container">
          <div className="relative inset-0 flex border border-b-gray-300">
            <img id="spotsnap-id" src={spotsnapimage} alt="Think5Whys SpotSnap Image" />
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default SpotSnapHome;


